import React from 'react'
import ReactDOM from 'react-dom/client'
import '@fontsource-variable/onest'
import { initAnalytics } from '@/lib/analytics'
import { findSitePage, opensCabinet } from '@/site/pages'

// Public pages arrive prerendered (scripts/prerender.mjs) and only need
// hydrating; everything else is the cabinet, loaded as its own chunk so the
// public pages never download it. A prerendered root names its page: the 404
// page is served at whatever URL was not found.
const root = document.getElementById('root')!
const page = findSitePage(root.dataset.page ?? window.location.pathname)
const site = Boolean(page && !opensCabinet(page))

if (site && page) {
  page.load().then(({ default: Page }) => {
    const tree = (
      <React.StrictMode>
        <Page />
      </React.StrictMode>
    )
    if (root.hasAttribute('data-ssr')) ReactDOM.hydrateRoot(root, tree)
    else ReactDOM.createRoot(root).render(tree)
  })
} else {
  // The home page's markup when nginx served it as the SPA fallback.
  if (root.hasAttribute('data-ssr')) {
    root.replaceChildren()
    root.removeAttribute('data-ssr')
  }
  import('./appMain').then((m) => m.mountApp(root))
}

// Event queues and click listeners start now, so no early click is lost; the
// third-party scripts themselves wait (lib/analytics.ts, whenQuiet). The
// cabinet counts no page views of its own.
initAnalytics({ pageviews: site })
